import { Link } from '@reach/router';
import '../App.css';

const Tail = () => {
    return (
        <>
        <div id="tail_wrap" className='unselectable'>
            <div>
                <p id="fine_print">
                Copyright ©2022 ShadowFlight. All rights reserved.
                </p>
            </div>
        </div>
        </>
    )
}
export default Tail;